import { useHistory } from 'react-router-dom';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import React, { useState } from 'react';
import './style.sass';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export default function SolicitudExitosaMobile() {
    const history = useHistory();

    const [flagDigital, setFlagDigital] = useState(false);
    const [flagFisico, setFlagFisico] = useState(true);
    const direccion = "Lago Zurich 256, Ampliación granada... ";

    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                    <HeaderMobileCredito logo="/img/logo-sears.svg" type="close" />

                    <div className="contenedorGeneral">
                        {flagDigital &&
                            <div className="boxSolicitudExitosa">
                                <div className="boxIconoSolicitudExitosa">
                                    <img src={`${BASE_PATH}${SUB_DIRECTORY}img/checkMark.png`} alt="logo-digital"></img>
                                </div>

                                <div className="boxCopysSolicitudExitosa">
                                    <h4>¡Gracias!</h4>
                                    <p>Tu solicitud se realizó con éxito</p>
                                </div>
                            </div>
                        }

                        {flagFisico &&
                            <div className="boxSolicitudExitosa">
                                <div className="boxIconoSolicitudExitosa">
                                    <img src={`${BASE_PATH}${SUB_DIRECTORY}img/checkMark.png`} alt="logo-digital"></img>
                                </div>

                                <div className="boxCopysSolicitudExitosa">
                                    <h4>Tu solicitud se realizó con éxito.</h4>
                                    <p>Recibirás tu estado de cuenta a tu domicilio registrado:</p>
                                    <p className="copyDireccion">{direccion}</p>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}